module.exports = __webpack_public_path__ + "img/蒙版组3022@2x.36cbe76b.png";